import { createFeatureSelector } from '@ngrx/store';
import { UserActivationState } from '../reducers/user-activation.reducer';

export const selectUserActivation = createFeatureSelector<UserActivationState>('userActivation');
